import { Layout } from "@/components/Layout";
import { MonteFaeta } from "@/components/MonteFaeta";

export default function MonteFaetaPage() {
  return (
    <Layout>
      <MonteFaeta />
    </Layout>
  );
}
